import React, { useState } from "react";
import { FaEye } from "react-icons/fa";
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const ForgotForm = () => {
    const validationSchema = Yup.object().shape({
      username: Yup.string()
        .email("Invalid email address")
        .required("Email address is required"),
    });
  
    const handleSubmit = (values, { setSubmitting }) => {
      // Your form submission logic here
      console.log(values);
      setSubmitting(false);
    };
  
    return (
      <div>
        <div className="containerL p-5 text-center ">
        <h3 className="text-white text-center mb-4">Forgot Password</h3>
        <Formik
          initialValues={{ username: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="form-group fg1">
                <label htmlFor="username">Enter your email address</label>
                <Field
                  type="email"
                  id="username"
                  name="username"
                  className="form-control mb-2"
                  placeholder="example@example.com"
                />
                <ErrorMessage
                  name="username"
                  component="div"
                  className="text-danger"
                />
              </div>
              <p className="txt">
                On submit, a password reset email will be sent, and the further
                process will be completed.
              </p>
              <button
                type="submit"
                className="btn btn-primary btn-login mx-auto"
                disabled={isSubmitting}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
        <div className="form-group">
          <a href="/" className="btn btn-link forget2">
            Back to home page
          </a>
        </div>
      </div>
      </div>
    );
  };
  
  export default ForgotForm;
